import { render, staticRenderFns } from "./AgenciesList.vue?vue&type=template&id=699f7486&"
import script from "./AgenciesList.vue?vue&type=script&lang=js&"
export * from "./AgenciesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports